$(document).ready(function() {
 //wrapper-tab
    $(document).on("click", ".tab-wrapper-btn", function() {
        if (!$(this).hasClass('active-tab-wrapper-btn')) {
            $(".tab-wrapper-btn").removeClass('active-tab-wrapper-btn');
            $(this).addClass('active-tab-wrapper-btn');
            var get_active_menu = $(this).attr("data-content");
            var get_class = "." + $(this).attr("data-content");
            $(".outer-wrapper.active").fadeOut(function() {
                $(".outer-wrapper").removeClass('active');
                $(get_class).addClass('active').fadeIn();
            });
            $(".header-menu-wrap.active").fadeOut(function() {
                $(".header-menu-wrap").removeClass('active');
                $("[data-menu=" + get_active_menu + "]").addClass('active').fadeIn();
            });

        }

        //header invite button show hide
        if ($(this).hasClass('new-invite-btn')) {
            $("body").addClass('stepper-active')
            $(".new-invite-btn").fadeOut();
        } else {
            $("body").removeClass('stepper-active')
            $(".new-invite-btn").fadeIn();
        }

    });
    });